import { render } from "./PageHeader.vue?vue&type=template&id=57c0dbb8"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/page-header/PageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57c0dbb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57c0dbb8', __exports__)) {
    api.reload('57c0dbb8', __exports__)
  }
  
  module.hot.accept("./PageHeader.vue?vue&type=template&id=57c0dbb8", () => {
    api.rerender('57c0dbb8', render)
  })

}


export default __exports__